import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

const DISPLAY = 'D.M.YYYY'
const PARSE = ['D.M.YYYY', 'DD.MM.YYYY', 'D.M.YY', 'DD.MM.YY', 'YYYY-MM-DD'] as const

export const formatDateRangeDay = (iso?: string) => (iso ? dayjs(iso).format(DISPLAY) : '')

export const parseDateRangeDay = (value: string): string | undefined => {
  const trimmed = value.trim()
  if (!trimmed) return undefined
  for (const format of PARSE) {
    const parsed = dayjs(trimmed, format, true)
    if (parsed.isValid()) return parsed.format('YYYY-MM-DD')
  }
  return undefined
}
